import ComponentState, { ComponentStateTypes } from "components/common/ComponentState";
import BooleanView from "components/common/views/BooleanView";
import PropertyView from "components/common/views/PropertyView";
import { useEffect, useState } from "react";
import { Maybe } from "types/graphql";
import { getSeasonData, SeasonType } from "types/season-type";

type SeasonViewPropsType = {
    model: string | number | SeasonType | undefined | null
}
const SeasonView = (props: SeasonViewPropsType) => {
    const [model, setModel] = useState<Maybe<SeasonType>>(typeof props.model == 'object' ? props.model : {} as Maybe<SeasonType>);
    const [state, setState] = useState<ComponentStateTypes>(props.model ? '' : 'nodata');
        
    // #region init
    useEffect(() => {
        if(typeof props.model != 'object') {
            const id = Number(props.model);
            if (id) {
                setState('loading');
                readData(id).then();
            } else {
                setState('error.not-valid-id');
            }
        }
    }, [props.model]);

    const readData = async (id: number) => {
        const response = await getSeasonData(id);
        try {
            if (response?.response.errors) {
                setState(response.response.errors.map(c => c.message).join(", "));
            } else if (response?.season) {
                setModel(response.season);
                setState('');
            } else {
                setState('nodata');
            }
        } catch (error: any) {
            console.error(error);
            setState('error');
        }
    }
    // #endregion init

    return (
        <ComponentState state={state}>
            <PropertyView label="fields.id.name" value={model?.id} />
            <PropertyView label="fields.name.name" value={model?.name} />
            <PropertyView label="fields.active.name" value={<BooleanView value={model?.active} />} />
        </ComponentState>
    );
};
export default SeasonView;
